export interface FundCity {
  city?: string;
  id?: number;
  state?: string;
}
